// Possibly consider computing this initially (rather than calculating on the fly) when creating view model,
// and also every time user data is edited, because this function is called

import { SHIFT } from 'models/baselines';
import { getDaySum, getNightSum } from '../Incrementals.helpers';
import { WorkCenterDay } from '../Incrementals.types';
import { UiQueries } from './UiQueries';

// for every work center on every re-render.
export function areMoreIncrementalsNeededQuery(
  this: UiQueries,
  shift: SHIFT,
  day: WorkCenterDay
) {
  const required = shift === SHIFT.DAY ? day.required.day : day.required.night;
  // if there is no required for this day,
  // there is no need for incrementals
  if (required === 0) {
    return false;
  }

  const incremental =
    shift === SHIFT.DAY
      ? getDaySum(day.incrementals)
      : getNightSum(day.incrementals);

  if (incremental < required) {
    return true;
  }

  return false;
}
